<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen">
    <template #content>
      <VaNavbar class="app-layout-navbar py-2 px-0">
        <template #left>
          <div class="left">
            <RouterLink :to="{ name: 'login', query: { signout: '1' } }" aria-label="Sign out and go to login">
              <p class="font-semibold text-2xl text-primary">HiTip</p>
            </RouterLink>
          </div>
        </template>
      </VaNavbar>
      <main
        class="notranslate h-full flex items-center justify-center mx-auto max-w-[420px] px-4 pt-[30px] pb-4"
        translate="no"
      >
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen">
    <template #content>
      <VaNavbar class="app-layout-navbar py-2 px-0">
        <template #left>
          <div class="left">
            <RouterLink :to="{ name: 'login', query: { signout: '1' } }" aria-label="Sign out and go to login">
              <p class="font-semibold text-2xl text-primary">HiTip</p>
            </RouterLink>
          </div>
        </template>
      </VaNavbar>
      <div class="px-4 pb-4 pt-[30px]">
        <main
          class="notranslate w-full h-full flex flex-row items-center justify-start mx-auto max-w-[480px]"
          translate="no"
        >
          <div class="w-full flex flex-col items-start">
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'

const breakpoint = useBreakpoint()
</script>
<style lang="scss" scoped>
.va-navbar {
  z-index: 2;
  background-color: transparent !important;
  border-bottom: 1px solid rgba(66, 71, 112, 0.09);

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
